import { render, staticRenderFns } from "./LawDocumentContentTypeList.vue?vue&type=template&id=43b9402e&"
import script from "./LawDocumentContentTypeList.vue?vue&type=script&lang=js&"
export * from "./LawDocumentContentTypeList.vue?vue&type=script&lang=js&"
import style0 from "./LawDocumentContentTypeList.vue?vue&type=style&index=0&id=43b9402e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports